__turbopack_context__.v({
  "container": "NEdBDW_container",
  "isSelected": "NEdBDW_isSelected",
  "itemLabel": "NEdBDW_itemLabel",
  "numbered": "NEdBDW_numbered",
  "sectionLabel": "NEdBDW_sectionLabel",
  "variant--solid": "NEdBDW_variant--solid",
});
